import { TableType } from 'app/lib/types/server';
import {
    DATA_SOURCE_REFERENCE_DTO_TYPE,
    SQL_VIEW_DTO_TYPE,
    TRANSFORMATION_STACK_DTO_TYPE,
    TRANSFORMATION_NODE_DTO_TYPE,
    QUERY_BUILDER_TYPE,
    COMBINE_TYPE,
    JOIN_TYPE,
    GENERIC_TRANSFORM_TYPE
} from 'app/store/__generated__/types';
import { GET_SPACE_SUCCESS_SPACE_DTO } from 'app/store/__generated__/events';

export const EXTRACT_JSON = 'EXTRACT_JSON';
export const GROUP_NODE = 'GROUP_NODE';
export const FILTER = 'FILTER';
export const MULTI_JOIN = 'MULTI_JOIN';
export const ERROR_NODE = 'ERROR_NODE';

export const JOBS = 'jobs';

export const GlossaryKeyByEntityType = {
    [DATA_SOURCE_REFERENCE_DTO_TYPE]: 'dataset',
    [TRANSFORMATION_STACK_DTO_TYPE]: 'dataset',
    [TRANSFORMATION_NODE_DTO_TYPE]: 'dataset',
    [GET_SPACE_SUCCESS_SPACE_DTO]: 'project',
    [SQL_VIEW_DTO_TYPE]: 'query',
    [COMBINE_TYPE]: 'union',
    [JOIN_TYPE]: 'join',
    [QUERY_BUILDER_TYPE]: 'query',
    [TableType.VIEW]: 'view',
    [TableType.TABLE]: 'table',
    SPACE: 'project',
    DATA_SOURCE: 'dataset',
    SOURCE_LOCATION: 'schema',
    [EXTRACT_JSON]: 'extractJson',
    [GROUP_NODE]: 'group'
};

export const DeployableViewTypes = [
    SQL_VIEW_DTO_TYPE,
    COMBINE_TYPE,
    JOIN_TYPE,
    TRANSFORMATION_STACK_DTO_TYPE,
    QUERY_BUILDER_TYPE,
    EXTRACT_JSON,
    GENERIC_TRANSFORM_TYPE,
    FILTER,
    MULTI_JOIN
];
